/**
 * OwnerDashboardReminder — banner discreto (non invasivo) mostrato in
 * cima ai pane di CAPISCI / VALUTA / DECIDI. Punta alla sezione
 * "La scrivania per ogni immobile" della home in una nuova scheda
 * (target="_blank") così l'utente NON perde il flusso corrente.
 *
 * Non è persistente in localStorage: appare ad ogni pagina — è
 * volutamente discreto per convertire lentamente.
 */
import React from "react";
import { BookmarkPlus, ExternalLink } from "lucide-react";
import { useAuth } from "@/lib/AuthContext";


export function OwnerDashboardReminder() {
  const { user } = useAuth();
  // Se l'utente è già loggato come owner, il richiamo non serve.
  if (user?.ruolo === "owner") return null;
  // §I-3B-R · "Salva questa analisi…" ha senso SOLO dove un'analisi esiste
  // già: lo mostriamo nella pagina del risultato, mai nella scheda iniziale
  // di compilazione (dove l'analisi non è ancora stata prodotta).
  const onResult = typeof window !== "undefined"
    && window.location.pathname.includes("/risultato/");
  if (!onResult) return null;
  return (
    <a
      href="/#owner-dashboard"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="owner-dashboard-reminder"
      className="
        inline-flex items-center gap-2 text-xs text-vg2-muted
        hover:text-vg2-red transition-colors mt-2
      "
    >
      <BookmarkPlus size={14} strokeWidth={1.6} />
      <span className="underline-offset-4 hover:underline">
        Salva questa analisi nel tuo profilo proprietario
      </span>
      <ExternalLink size={11} strokeWidth={1.6} className="opacity-60" />
    </a>
  );
}
